//Relative path from root folder (src) ../../../

/* 
 * Export component file to be used on project
*/

import MessageWithDate from './MessageWithDate';
export default MessageWithDate;
